import { requestToken } from "./request_method";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/report`;

class ReportServices {
  // SALE PERSON REPORT
  async getSalesReport() {
    try {
      let action = API_ROUTE + "/getsalesreport";
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
}

export default ReportServices;
